import { Component, Input } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'skeletor-document-requirements',
  standalone: true,
  imports: [CommonModule, NgFor, SkeletonModule],
  templateUrl: './document-requirements.template.component.html',
  styleUrls: ['./document-requirements.template.component.scss']
})
export class SkeletorDocumentRequirementsTemplateComponent {
  @Input() items: number = 6;
  get rows() { return Array.from({ length: this.items }); }
}

